<greco-user-profile-details [user]="userDetails.user" [alwaysOpen]="true" [readonly]="readonly">
</greco-user-profile-details>

<button mat-icon-button (click)="dialogRef.close()" style="position: absolute; top: 12px; right: 12px; z-index: 999">
  <mat-icon>close</mat-icon>
</button>
